import { WebComponents } from "@/interfaces";
import { URLS } from "../../utils";

export const webComponents: { title: string; path: string; componentIds: WebComponents[] | WebComponents }[] = [
  {
    title: "Library",
    path: URLS.coach.library,
    componentIds: [
      WebComponents.PROMPTS,
      WebComponents.MANAGE_SCRIPT_LIBRARY,
      WebComponents.VIDEO_CATALYST,
      WebComponents.VIDEO_PAGES,
    ],
  },
  {
    title: "Campaigns",
    path: URLS.coach.campaigns,
    componentIds: WebComponents.CAMPAIGNS,
  },
  {
    title: "Calendar",
    path: URLS.coach.calendar,
    componentIds: WebComponents.CALENDAR,
  },
  {
    title: "Compliance Manager",
    path: URLS.coach.compliance,
    componentIds: WebComponents.COMPLIANCE,
  },
  {
    title: "Reputation Manager",
    path: URLS.coach.reputation.overview,
    componentIds: [WebComponents.REPUTATION_MANAGEMENT],
  },
  {
    title: "Users",
    path: URLS.coach.users,
    componentIds: [WebComponents.PLAYERS, WebComponents.ASSISTANTS],
  },
  {
    title: "Player Cards",
    path: URLS.coach.playerCards,
    componentIds: WebComponents.PLAYER_CARDS,
  },
  {
    title: "Alerts",
    path: URLS.coach.alerts,
    componentIds: WebComponents.ALERTS,
  },
  {
    title: "Settings",
    path: URLS.coach.settings,
    componentIds: [WebComponents.APP_SETTINGS, WebComponents.API_KEYS],
  },
];

export const playerWebOptions = [
  {
    title: "Dashboard",
    path: URLS.player.dashboard,
  },
  {
    title: "Library",
    path: URLS.player.libraryTab.replace(":tab?", ""),
  },
  {
    title: "Calendar",
    path: URLS.player.calendar,
  },
  {
    title: "Review Inbox",
    path: URLS.player.reputation.tab.replace(":tab?", "inbox"),
  },
  {
    title: "Player Card",
    path: URLS.player.playerCards,
  },
  {
    title: "Settings",
    path: URLS.player.settings.replace(":tab?", ""),
  },
];
